import * as React from "react";
import clsx from "clsx";
import { Button, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Edit } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  editButton: {
    "& svg, & path": {
      fill: "#3F51B5",
    },

    padding: 0,
    minWidth: "auto",
    display: "none",
    width: 24,
    height: 24,
  },
}));

export default function EditButton({ onClick, className }) {
  const classes = useStyles();
  return (
    <Button onClick={onClick} className={clsx(classes.editButton, className)}>
      <Edit style={{ width: 16, height: 16 }} />
    </Button>
  );
}
